var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListsSettingsCreatorDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.5C5.5 8.42826 5.86875 9.3185 6.52513 9.97487C7.1815 10.6313 8.07174 11 9 11C9.92826 11 10.8185 10.6313 11.4749 9.97487C12.1313 9.3185 12.5 8.42826 12.5 7.5C12.5 6.57174 12.1313 5.6815 11.4749 5.02513C10.8185 4.36875 9.92826 4 9 4C8.07174 4 7.1815 4.36875 6.52513 5.02513C5.86875 5.6815 5.5 6.57174 5.5 7.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6087 14.9174C13.0048 14.3098 12.2868 13.8275 11.4958 13.4985C10.7049 13.1694 9.85667 13 9 13C8.14334 13 7.29513 13.1694 6.50419 13.4985C5.71325 13.8275 4.99519 14.3098 4.39133 14.9174",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9C1.5 10.9891 2.29018 12.8968 3.6967 14.3033C5.10322 15.7098 7.01088 16.5 9 16.5C10.9891 16.5 12.8968 15.7098 14.3033 14.3033C15.7098 12.8968 16.5 10.9891 16.5 9C16.5 7.01088 15.7098 5.10322 14.3033 3.6967C12.8968 2.29018 10.9891 1.5 9 1.5C7.01088 1.5 5.10322 2.29018 3.6967 3.6967C2.29018 5.10322 1.5 7.01088 1.5 9Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListsSettingsCreatorDropdownIcon);
export default __webpack_public_path__ + "static/media/ListsSettingsCreatorDropdownIcon.c77d04bde7578a7fb4507c18c6275f9c.svg";
export { ForwardRef as ReactComponent };